export default [
    {
        path: '/cobertura/index',
        name: 'CoberturaView',
        component: () => import('../views/catalogos/CoberturaView.vue')
    },
    {
        path: '/tipo-vehiculo/index',
        name: 'TipoVehiculoView',
        component: () => import('../views/catalogos/TipoVehiculoView.vue')
    },
    {
        path: '/informacion-patio-vehiculo/index',
        name: 'InformacionPatioVehiculoView',
        component: () => import('../views/catalogos/InformacionPatioVehiculoView.vue')
    },
    {
        path: '/contratante/index',
        name: 'ContratanteView',
        component: () => import('../views/catalogos/ContratanteView.vue')
    },
    {
        path: '/cliente/index',
        name: 'ClienteView',
        component: () => import('../views/catalogos/ClienteView.vue')
    },
]